import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { CompanyEmailTemplate, EmailTemplateKey } from 'src/app/inside-layout/routes/companies/companies.models';
import { TranslateService } from '@ngx-translate/core';
import { Dialog, DialogService } from 'src/app/core/dialog.service';
import { AlertService } from 'src/app/core/alert.service';
import { ValueLabel } from '../base/base.models';
import { UtilityService } from 'src/app/core/utility.service';

@Component({
  selector: 'app-email-templates',
  templateUrl: './email-templates.component.html',
  styleUrls: ['./email-templates.component.scss']
})
export class EmailTemplatesComponent implements OnInit {
  @Input('default') default: boolean = false;
  @Input('emailTemplates') emailTemplates: CompanyEmailTemplate[] = [];
  @Input('canUpdate') canUpdate: boolean = false;
  @Output() saveEvent?= new EventEmitter();
  @Output() saveSingleEvent?= new EventEmitter();
  @Output() deleteSingleEvent?= new EventEmitter();

  public isEmailTemplateFormVisible: boolean = false;
  public selectedTemplate: CompanyEmailTemplate;
  public emailTemplateKeys: ValueLabel[] = [];

  public key: string | EmailTemplateKey;
  public subject: string;
  public body: string;
  public attachmentLink: string;
  public description: string;

  public emailTemplatePopupTitle: string;

  constructor(private translateService: TranslateService, private alertService: AlertService, private dialogService: DialogService, private utilityService: UtilityService) { }

  ngOnInit(): void {
    this.prepareLookupData();
  }

  private prepareLookupData() {
    this.emailTemplateKeys = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(EmailTemplateKey, true), 'value', 'label', 'ENUMS.EMAIL_TEMPLATE_KEYS.');
  }

  onToolbarPreparing(event) {
    if (this.canUpdate) {
      event.toolbarOptions.items.unshift({
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'plus',
          hint: this.translateService.instant('DEV-EXTREME.dxDataGrid-editingAddRow'),
          text: this.translateService.instant('DEV-EXTREME.dxDataGrid-editingAddRow'),
          showText: 'inMenu',
          onClick: this.openCreateForm.bind(this)
        },
        locateInMenu: 'auto'
      });
      
      if (!this.default) {
        event.toolbarOptions.items.unshift({
          location: 'after',
          widget: 'dxButton',
          options: {
            icon: 'trash',
            hint: this.translateService.instant('SHARED.DELETE_ALL'),
            text: this.translateService.instant('SHARED.DELETE_ALL'),
            showText: 'inMenu',
            onClick: this.deleteAllItems.bind(this)
          },
          locateInMenu: 'auto'
        });
      }
    }
  }

  public deleteAllItems() {
    let dialog = new Dialog('EMAIL_TEMPLATES.DELETE_ALL_ITEMS', () => {
      this.emailTemplates = [];
      this.saveEvent.emit(this.emailTemplates);
      this.alertService.success('EMAIL_TEMPLATES.DELETE_ALL_ITEMS_SUCCESS');
    });

    this.dialogService.show(dialog);
  }

  delete(key: string) {
    let index;
    if (!this.default) {
      index = this.emailTemplates.findIndex(t => t.key == key);
    } else {
      index = this.emailTemplates.findIndex(t => t.id == key);
    }

    if (index > -1) {
      let dialog = new Dialog('SHARED.DELETE_QUESTION', () => {
        if (!this.default) {
          this.emailTemplates.splice(index, 1);
          this.saveEvent.emit(this.emailTemplates);
        } else {
          this.deleteSingleEvent.emit(key);
        }
      });

      this.dialogService.show(dialog);
    }
  }

  edit(template: CompanyEmailTemplate) {
    this.selectedTemplate = template;
    this.key = template.key;
    this.subject = template.subject;
    this.body = template.body;
    this.attachmentLink = template.attachmentLink;
    this.description = template.description;
    this.emailTemplatePopupTitle = 'EMAIL_TEMPLATES.EDIT_TITLE';
    this.isEmailTemplateFormVisible = true;
  }

  openCreateForm() {
    this.emailTemplatePopupTitle = 'EMAIL_TEMPLATES.CREATE_TITLE';
    this.isEmailTemplateFormVisible = true;
  }

  saveEmailTemplate() {
    if (!this.default) {
      let index = this.emailTemplates.findIndex(t => t.key == this.key);

      let template = {
        key: this.key,
        subject: this.subject,
        body: this.body,
        attachmentLink: this.attachmentLink
      };

      if (index > -1) {
        this.emailTemplates[index] = template;
      } else {
        this.emailTemplates.push(template);
      }

      this.saveEvent.emit(this.emailTemplates);
      this.closeEmailTemplateFormModal();
    } else {
      let index = this.selectedTemplate ? this.emailTemplates.findIndex(t => t.id == this.selectedTemplate.id) : -1;

      let template: CompanyEmailTemplate;
      if (index > -1) {
        template = this.selectedTemplate;
        template.key = this.key,
          template.subject = this.subject,
          template.body = this.body,
          template.attachmentLink = this.attachmentLink;
          template.description = this.description;

        this.emailTemplates[index] = template;
      } else {
        template = {
          key: this.key,
          subject: this.subject,
          body: this.body,
          attachmentLink: this.attachmentLink,
          description: this.description
        };
      }

      this.saveSingleEvent.emit(template);
    }
  }

  closeEmailTemplateFormModal() {
    this.selectedTemplate = null;
    this.key = null;
    this.subject = null;
    this.body = null;
    this.attachmentLink = null;
    this.description = null;
    this.isEmailTemplateFormVisible = false;
  }
}
